import Cookies from 'js-cookie';
import { jwtDecode } from 'jwt-decode';

const COOKIE_ACCESS_TOKEN_NAME = 'access_token';
const COOKIE_REFRESH_TOKEN_NAME = 'refresh_token';

export default {
  setToken(token: API.AuthTokenType, autoLogin: boolean) {
    const expiresInMilliseconds: number = token.expires_in
      ? token.expires_in * 1000
      : (jwtDecode(token.access_token) as API.TokenType).exp * 1000;
    const expiresAt = expiresInMilliseconds;
    const expires = new Date(expiresAt);

    const accessTokenCookieOptions: Cookies.CookieAttributes | undefined = {
      //domain: ServiceConstants.DOMAIN,
    };
    const refreshTokenCookieOptions: Cookies.CookieAttributes | undefined = {
      //domain: ServiceConstants.DOMAIN,
    };

    if (autoLogin) {
      accessTokenCookieOptions.expires = expires;
      const twoDaysLater = new Date(expires);
      twoDaysLater.setDate(expires.getDate() + 2);
      refreshTokenCookieOptions.expires = twoDaysLater;
    }

    Cookies.set(COOKIE_ACCESS_TOKEN_NAME, token.access_token, accessTokenCookieOptions);
    Cookies.set(COOKIE_REFRESH_TOKEN_NAME, token.refresh_token, refreshTokenCookieOptions);
  },

  getAccessToken() {
    const access_token = Cookies.get(COOKIE_ACCESS_TOKEN_NAME);
    if (access_token !== undefined) {
      return access_token;
    }
    return undefined;
  },
  getRefreshToken() {
    const refresh_token = Cookies.get(COOKIE_REFRESH_TOKEN_NAME);
    if (refresh_token !== undefined) {
      return refresh_token;
    }
    return undefined;
  },
  getAccessTokenExpiration(): Date | undefined {
    const access_token = this.decodeAccessToken();
    if (access_token !== undefined) {
      return new Date(Number(access_token.exp) * 1000);
    }
    return undefined;
  },

  isAccessTokenExpired() {
    const expire_date = this.getAccessTokenExpiration();

    if (expire_date !== undefined) {
      const now = new Date();

      return now > expire_date;
    } else {
      return true;
    }
  },
  decodeAccessToken(): API.TokenType | undefined {
    const access_token = this.getAccessToken();
    if (access_token !== undefined) {
      return jwtDecode(access_token) as API.TokenType;
    }
    return undefined;
  },
  checkTokenIfIsValid() {
    const access_token = this.decodeAccessToken();
    if (access_token !== undefined) {
      if (this.isAccessTokenExpired()) {
        return false;
      }
      return true;
    }
    return false;
  },
  removeAccessToken() {
    //{ domain: `.${ServiceConstants.DOMAIN}` }
    Cookies.remove(COOKIE_ACCESS_TOKEN_NAME);
  },
  removeRefreshToken() {
    //{ domain: `.${ServiceConstants.DOMAIN}` }
    Cookies.remove(COOKIE_REFRESH_TOKEN_NAME);
  },

  removeLogoutCookies() {
    this.removeAccessToken();
    this.removeRefreshToken();
  },
};
